import { Tbody, Td, Tr } from '@chakra-ui/react';

export function InfoGerais({ chamado }) {
  return (
    <Tbody>
      <Tr>
        <Td textAlign="center" fontWeight="bold">
          {chamado?.quantidade_chamados_dia}
        </Td>
        <Td textAlign="center" fontWeight="bold">
          {chamado?.chamados_site}
        </Td>
        <Td textAlign="center" fontWeight="bold">
          {chamado?.chamados_wp}
        </Td>
        <Td textAlign="center" fontWeight="bold">
          {chamado?.chamados_atendimento}
        </Td>
        <Td textAlign="center" fontWeight="bold">
          {chamado?.quantidade_novos}
        </Td>
      </Tr>
    </Tbody>
  );
}
